import { combineReducers } from 'redux'
import ServiceCenterAdminsTypes from 'store/actionTypes/serviceCenterAdmin'
import { createHandleRequest } from './helpers'

const getServiceCenterAdmins = createHandleRequest(
  ServiceCenterAdminsTypes.GET_SERVICE_CENTER_ADMINS_REQUEST,
  ServiceCenterAdminsTypes.GET_SERVICE_CENTER_ADMINS_SUCCESS,
  ServiceCenterAdminsTypes.GET_SERVICE_CENTER_ADMINS_FAILED
)

export default combineReducers({
  getServiceCenterAdmins
})
